import { useState } from 'react';
import Footer from '../Components/Footer'
import { useTranslation } from 'react-i18next'
import { Box, Chip, Container, Grid, Paper, Stack, Tab, Tabs, Typography } from '@mui/material';
import { AnimatePresence, Variants, motion } from "framer-motion"
import DrawerAppBar from '../Components/DrawerAppBar';
import Menus from '../Components/Menus';
import TitrePage from '../Components/TitrePage';
import { useNavigate } from 'react-router-dom';
import { AccessTime, CheckCircle, Email, Event, LocationOn, Phone, Place, Store, Verified, Celebration } from '@mui/icons-material';
import EllipseGauche from "../Fichiers/Ellipse 200.svg"
import EllipseDroite from "../Fichiers/Ellipse 201.svg"
import illution_4 from "../Fichiers/illution_4.svg";

interface Props { }

interface Compte {
    nom: string,
    sous: string,
    versement: string,
    pieces: string
}

const VERT = "#0d6638";
const VERT_FONCE = "#084123";
const ORANGE = "#FF7D12";
const VERT_CLAIR = "#F1FFF8";
const GRIS = "#637381";

function FinanceIslamique(props: Props) {
        const { t } = useTranslation();
    const navigate = useNavigate()
    const [onglet, setOnglet] = useState(0);

    const scroll: Variants = {
        offscreen: { y: 60, opacity: 0 },
        onscreen: { y: 0, opacity: 1, transition: { bounce: 0.4, duration: 0.8 } }
    };

    const horaires = t("FINANCE_ISLAMIQUE.horaires.liste").split("|").map(h => h.split(";"));
    const pourquoi = t("FINANCE_ISLAMIQUE.pourquoi.liste").split("|");
    const agences = t("FINANCE_ISLAMIQUE.agences.liste").split("|").map(a => a.split(";"));
    const adhesion = t("FINANCE_ISLAMIQUE.adhesion.liste").split("|").map(a => a.split(";"));
    const comptes = t("FINANCE_ISLAMIQUE.comptes.liste", { returnObjects: true }) as unknown as Compte[];
    const compte = Array.isArray(comptes) ? comptes[onglet] : undefined;

    const titreSection = (texte: string) => (
        <Box textAlign="center" mb={4}>
            <img width={120} src={illution_4} alt="" />
            <Typography variant="h4" fontWeight="bold" color={VERT} sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}>{texte}</Typography>
        </Box>
    )

    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre38'} lien={'PRODUITS_SERVICES.titre38'} />

            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            <Box display={{ xs: 'block', sm: 'none' }}><br /><br /></Box>

            {/* HERO */}
            <Box display={"flex"} lineHeight={1.6}>
                <Box display={{ xs: "none", sm: "contents" }}>
                    <img style={{ width: "5%" }} draggable={false} src={EllipseGauche} alt="" />
                </Box>
                <Container maxWidth='lg'>
                    <Grid container spacing={6} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll}>
                                <Chip icon={<Verified style={{ color: "white" }} />} label={t("FINANCE_ISLAMIQUE.hero.badge")} sx={{ bgcolor: VERT, color: "white", fontWeight: "bold", mb: 2, height: "auto", py: .5, "& .MuiChip-label": { whiteSpace: "normal" } }} />
                                <Typography variant="h3" fontWeight="bold" color={VERT} sx={{ fontSize: { xs: "1.9rem", sm: "2.6rem" } }}>
                                    {t("FINANCE_ISLAMIQUE.hero.titre")}
                                </Typography>
                                <Typography variant="h6" fontStyle="italic" color={ORANGE} fontWeight="bold" gutterBottom>
                                    « {t("FINANCE_ISLAMIQUE.hero.slogan")} »
                                </Typography>
                                <Typography className='textgray' sx={{ width: "100% !important", textAlign: "justify" }}>
                                    {t("FINANCE_ISLAMIQUE.hero.texte")}
                                </Typography>
                                <Stack direction="row" gap={2} mt={3} flexWrap="wrap">
                                    <motion.button onClick={() => navigate("/DevenirMembre")} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className='btn' style={{ padding: "12px 24px" }}>
                                        {t("FINANCE_ISLAMIQUE.hero.bouton1")}
                                    </motion.button>
                                    <motion.button onClick={() => navigate("/Contact")} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className='btn' style={{ padding: "12px 24px", backgroundColor: "transparent", color: VERT, border: `2px solid ${VERT}` }}>
                                        {t("FINANCE_ISLAMIQUE.hero.bouton2")}
                                    </motion.button>
                                </Stack>
                            </motion.div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <motion.div initial={{ opacity: 0, scale: .9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: .8 }}>
                                <Box position="relative" display="flex" justifyContent="center">
                                    <img
                                        style={{ width: "100%", maxWidth: 420, borderTopLeftRadius: "30%", borderTopRightRadius: "10%", borderBottomLeftRadius: "10%", borderBottomRightRadius: "30%", boxShadow: "0 20px 50px rgba(8,65,35,.25)" }}
                                        src={require("../Database/Files/ProduitsEtServices/Finance Islamique/2.png")} alt="" />
                                    <Paper elevation={6} sx={{ position: "absolute", bottom: -20, left: { xs: 8, md: -10 }, px: 2, py: 1.5, borderRadius: 3, display: "flex", alignItems: "center", gap: 1.5, bgcolor: "white" }}>
                                        <Box sx={{ bgcolor: ORANGE, color: "white", borderRadius: "50%", p: 1, display: "flex" }}><Celebration /></Box>
                                        <Box textAlign="left">
                                            <Typography variant="caption" color={GRIS} fontWeight="bold" textTransform="uppercase">{t("FINANCE_ISLAMIQUE.evenement.surtitre")}</Typography>
                                            <Typography fontWeight="bold" color={VERT}>{t("FINANCE_ISLAMIQUE.evenement.date")}</Typography>
                                        </Box>
                                    </Paper>
                                </Box>
                            </motion.div>
                        </Grid>
                    </Grid>
                </Container>
                <Box display={{ xs: "none", sm: "contents" }}>
                    <img style={{ width: "5%" }} draggable={false} src={EllipseDroite} alt="" />
                </Box>
            </Box>

            <br /><br /><br /><br />

            {/* EVENEMENT */}
            <Container maxWidth='lg' id="evenement">
                <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll}>
                    <Paper elevation={0} sx={{
                        borderRadius: 5, overflow: "hidden", color: "white", position: "relative",
                        background: `linear-gradient(135deg, ${VERT_FONCE} 0%, ${VERT} 60%, #148a4b 100%)`,
                        p: { xs: 3, md: 6 }
                    }}>
                        <Box sx={{ position: "absolute", right: -60, top: -60, width: 260, height: 260, borderRadius: "50%", bgcolor: "rgba(255,125,18,.25)" }} />
                        <Box sx={{ position: "absolute", left: -80, bottom: -100, width: 260, height: 260, borderRadius: "50%", bgcolor: "rgba(255,255,255,.06)" }} />
                        <Box position="relative" textAlign="left">
                            <Chip label={t("FINANCE_ISLAMIQUE.evenement.surtitre").toUpperCase()} sx={{ bgcolor: ORANGE, color: "white", fontWeight: "bold", letterSpacing: 2, mb: 2 }} />
                            <Typography variant="h4" fontWeight="bold" sx={{ fontSize: { xs: "1.4rem", md: "2.2rem" }, textTransform: "uppercase", maxWidth: 800 }}>
                                {t("FINANCE_ISLAMIQUE.evenement.titre")}
                            </Typography>
                            <Typography sx={{ opacity: .8, mt: 1, fontStyle: "italic" }}>{t("FINANCE_ISLAMIQUE.evenement.enseigne")}</Typography>

                            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 2, mt: 4 }}>
                                {[
                                    { icone: <Event />, label: t("FINANCE_ISLAMIQUE.evenement.date_label"), valeur: t("FINANCE_ISLAMIQUE.evenement.date") },
                                    { icone: <AccessTime />, label: t("FINANCE_ISLAMIQUE.evenement.heure_label"), valeur: t("FINANCE_ISLAMIQUE.evenement.heure") },
                                    { icone: <Place />, label: t("FINANCE_ISLAMIQUE.evenement.lieu_label"), valeur: t("FINANCE_ISLAMIQUE.evenement.lieu") },
                                ].map((e, i) => (
                                    <Box key={i} sx={{ bgcolor: "rgba(255,255,255,.1)", border: "1px solid rgba(255,255,255,.2)", borderRadius: 3, p: 2, display: "flex", gap: 1.5, alignItems: "flex-start" }}>
                                        <Box sx={{ bgcolor: ORANGE, borderRadius: 2, p: 1, display: "flex" }}>{e.icone}</Box>
                                        <Box>
                                            <Typography variant="caption" sx={{ opacity: .8, textTransform: "uppercase", letterSpacing: 1 }}>{e.label}</Typography>
                                            <Typography fontWeight="bold">{e.valeur}</Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>

                            <Stack direction="row" gap={2} flexWrap="wrap" alignItems="center" sx={{ pt: 7 }}>
                                <motion.button
                                    onClick={() => window.open("https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Mosquée Dada Ahidjo Foulbéré Garoua"), "_blank")}
                                    whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className='btn' style={{ padding: "12px 24px", display: "flex", alignItems: "center", gap: 8 }}>
                                    <LocationOn fontSize="small" /> {t("FINANCE_ISLAMIQUE.evenement.qr")}
                                </motion.button>
                                <motion.button onClick={() => navigate("/Agences")} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className='btn2' style={{ padding: "12px 24px", borderRadius: 100 }}>
                                    {t("PRODUITS_SERVICES.titre43")}
                                </motion.button>
                            </Stack>
                        </Box>
                    </Paper>
                </motion.div>
            </Container>

            <br /><br /><br /><br />

            {/* POURQUOI + HORAIRES */}
            <Box sx={{ bgcolor: VERT_CLAIR, py: 8 }}>
                <Container maxWidth='lg'>
                    <Grid container spacing={5}>
                        <Grid item xs={12} md={7}>
                            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll}>
                                <Box textAlign="left">
                                    <img width={120} src={illution_4} alt="" />
                                    <Typography variant="h4" fontWeight="bold" color={VERT} sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}>{t("FINANCE_ISLAMIQUE.pourquoi.titre")}</Typography>
                                </Box>
                                <Stack gap={2} mt={3}>
                                    {pourquoi.map((p, i) => (
                                        <motion.div key={i} whileHover={{ x: 8 }}>
                                            <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, display: "flex", gap: 2, alignItems: "center", borderLeft: `5px solid ${ORANGE}`, boxShadow: "0 5px 20px rgba(8,65,35,.08)" }}>
                                                <CheckCircle sx={{ color: VERT, fontSize: 32 }} />
                                                <Typography textAlign="left" color="#333" fontWeight={500}>{p}</Typography>
                                            </Paper>
                                        </motion.div>
                                    ))}
                                </Stack>
                            </motion.div>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll}>
                                <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden", boxShadow: "0 10px 30px rgba(8,65,35,.12)", height: "100%" }}>
                                    <Box sx={{ bgcolor: VERT, color: "white", p: 2.5, display: "flex", alignItems: "center", gap: 1.5 }}>
                                        <AccessTime />
                                        <Typography variant="h6" fontWeight="bold">{t("FINANCE_ISLAMIQUE.horaires.titre")}</Typography>
                                    </Box>
                                    <Box p={3} bgcolor="white">
                                        {horaires.map(([jour, heure], i) => (
                                            <Box key={i} sx={{ display: "flex", justifyContent: "space-between", gap: 2, py: 1.5, borderBottom: i < horaires.length - 1 ? "1px dashed #ddd" : "none" }}>
                                                <Typography fontWeight="bold" color={VERT} textAlign="left">{jour}</Typography>
                                                <Typography color={GRIS} textAlign="right">{heure}</Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Paper>
                            </motion.div>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <br /><br /><br />

            {/* AGENCES */}
            <Container maxWidth='lg'>
                {titreSection(t("FINANCE_ISLAMIQUE.agences.titre"))}
                <Typography color={GRIS} textAlign="center" mb={4}>{t("FINANCE_ISLAMIQUE.agences.texte")}</Typography>
                <Grid container spacing={3}>
                    {agences.map(([nom, adresse, tel], i) => (
                        <Grid item xs={12} sm={6} md={3} key={i}>
                            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll} transition={{ delay: i * .1 }} style={{ height: "100%" }}>
                                <motion.div whileHover={{ y: -8 }} style={{ height: "100%" }}>
                                    <Paper elevation={0} sx={{ p: 3, borderRadius: 4, height: "100%", textAlign: "left", bgcolor: VERT_CLAIR, border: "1px solid rgba(13,102,56,.12)", display: "flex", flexDirection: "column", gap: 1.5, boxSizing: "border-box" }}>
                                        <Box sx={{ display: { xs: "flex", md: "block" }, alignItems: "center", gap: 1.5 }}>
                                            <Box sx={{ width: 52, height: 52, flexShrink: 0, borderRadius: 3, bgcolor: VERT, color: "white", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <Store />
                                            </Box>
                                            <Typography fontWeight="bold" color={VERT} lineHeight={1.3}>{nom}</Typography>
                                        </Box>
                                        <Stack direction="row" gap={1} alignItems="flex-start">
                                            <Place sx={{ color: ORANGE, fontSize: 20 }} />
                                            <Typography variant="body2" color={GRIS}>{adresse}</Typography>
                                        </Stack>
                                        <Stack direction="row" gap={1} alignItems="center" mt="auto">
                                            <Phone sx={{ color: ORANGE, fontSize: 20 }} />
                                            <Typography variant="body2" fontWeight="bold" color="#333" component="a" href={"tel:" + tel.replace(/\s/g, "")} sx={{ textDecoration: "none" }}>{tel}</Typography>
                                        </Stack>
                                    </Paper>
                                </motion.div>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            <br /><br /><br /><br />

            {/* ADHESION + COMPTES */}
            <Box sx={{ bgcolor: VERT_CLAIR, py: 8 }}>
                <Container maxWidth='lg'>
                    {titreSection(t("FINANCE_ISLAMIQUE.adhesion.titre"))}
                    <Grid container spacing={5}>
                        <Grid item xs={12} md={4}>
                            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll}>
                                <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden", boxShadow: "0 10px 30px rgba(8,65,35,.12)" }}>
                                    <Box sx={{ background: `linear-gradient(135deg, ${ORANGE}, #ff9a47)`, color: "white", p: 3, textAlign: "left" }}>
                                        <Typography variant="h6" fontWeight="bold" textTransform="uppercase">{t("FINANCE_ISLAMIQUE.adhesion.sousTitre")}</Typography>
                                        <Typography variant="body2" sx={{ opacity: .9 }}>{t("FINANCE_ISLAMIQUE.adhesion.texte")}</Typography>
                                    </Box>
                                    <Box p={3} bgcolor="white">
                                        {adhesion.map(([libelle, montant], i) => (
                                            <Box key={i} sx={{ display: "flex", justifyContent: "space-between", gap: 2, py: 1.5, borderBottom: "1px dashed #ddd" }}>
                                                <Typography color={GRIS} textAlign="left">{libelle}</Typography>
                                                <Typography fontWeight="bold" color="#333" whiteSpace="nowrap">{montant}</Typography>
                                            </Box>
                                        ))}
                                        <Box sx={{ display: "flex", justifyContent: "space-between", pt: 2 }}>
                                            <Typography fontWeight="bold" color={VERT}>{t("FINANCE_ISLAMIQUE.adhesion.total_label")}</Typography>
                                            <Typography variant="h6" fontWeight="bold" color={ORANGE}>{t("FINANCE_ISLAMIQUE.adhesion.total")}</Typography>
                                        </Box>
                                    </Box>
                                </Paper>
                                <Box mt={3} display={{ xs: "none", md: "block" }}>
                                    <img style={{ width: "100%", borderRadius: 24, boxShadow: "0 10px 30px rgba(8,65,35,.12)" }} src={require("../Database/Files/ProduitsEtServices/Finance Islamique/1.png")} alt="" />
                                </Box>
                            </motion.div>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll}>
                                <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden", boxShadow: "0 10px 30px rgba(8,65,35,.12)", bgcolor: "white" }}>
                                    <Box p={3} pb={0} textAlign="left">
                                        <Typography variant="h6" fontWeight="bold" color={VERT} textTransform="uppercase">{t("FINANCE_ISLAMIQUE.comptes.titre")}</Typography>
                                        <Typography variant="body2" color={GRIS}>{t("FINANCE_ISLAMIQUE.comptes.texte")}</Typography>
                                    </Box>
                                    <Tabs
                                        value={onglet} onChange={(_, v) => setOnglet(v)}
                                        variant="scrollable" scrollButtons allowScrollButtonsMobile
                                        sx={{ px: 2, mt: 1, borderBottom: "1px solid #eee", "& .MuiTab-root": { fontWeight: "bold", textTransform: "none" }, "& .Mui-selected": { color: `${ORANGE} !important` }, "& .MuiTabs-indicator": { bgcolor: ORANGE, height: 3 } }}
                                    >
                                        {Array.isArray(comptes) && comptes.map((c, i) => <Tab key={i} label={c.nom} />)}
                                    </Tabs>
                                    <AnimatePresence mode="wait">
                                        {compte && (
                                            <motion.div key={onglet} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: .25 }}>
                                                <Box p={3} textAlign="left">
                                                    <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} gap={1} mb={2}>
                                                        <Box>
                                                            <Typography variant="h6" fontWeight="bold" color="#333">{compte.nom}</Typography>
                                                            <Typography variant="body2" color={GRIS}>{compte.sous}</Typography>
                                                        </Box>
                                                        <Chip label={`${t("FINANCE_ISLAMIQUE.comptes.versement")} : ${compte.versement}`} sx={{ bgcolor: "rgba(255,125,18,.12)", color: ORANGE, fontWeight: "bold", height: "auto", py: .5, "& .MuiChip-label": { whiteSpace: "normal" } }} />
                                                    </Stack>
                                                    <Stack gap={1.2}>
                                                        {compte.pieces.split("|").map((p, i) => (
                                                            <Box key={i} sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", p: 1.5, borderRadius: 2, bgcolor: VERT_CLAIR }}>
                                                                <Box sx={{ minWidth: 26, height: 26, borderRadius: "50%", bgcolor: VERT, color: "white", fontSize: 12, fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center" }}>{i + 1}</Box>
                                                                <Typography variant="body2" color="#333">{p.trim()}</Typography>
                                                            </Box>
                                                        ))}
                                                    </Stack>
                                                </Box>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </Paper>
                            </motion.div>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <br /><br /><br />

            {/* CONTACT / CTA */}
            <Container maxWidth='lg'>
                <motion.div initial="offscreen" whileInView="onscreen" viewport={{ once: true, amount: 0 }} variants={scroll}>
                    <Paper elevation={0} sx={{ borderRadius: 5, p: { xs: 3, md: 5 }, background: `linear-gradient(135deg, ${VERT_FONCE}, ${VERT})`, color: "white" }}>
                        <Grid container spacing={4} alignItems="center">
                            <Grid item xs={12} md={5} textAlign="left">
                                <Typography variant="h4" fontWeight="bold" sx={{ fontSize: { xs: "1.5rem", md: "2rem" } }}>{t("FINANCE_ISLAMIQUE.cta.titre")}</Typography>
                                <Typography sx={{ opacity: .85, mt: 1 }}>{t("FINANCE_ISLAMIQUE.cta.texte")}</Typography>
                                <motion.button onClick={() => navigate("/Contact")} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className='btn' style={{ padding: "12px 28px", marginTop: 24 }}>
                                    {t("FINANCE_ISLAMIQUE.cta.bouton")}
                                </motion.button>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography variant="overline" sx={{ opacity: .7, letterSpacing: 2 }}>{t("FINANCE_ISLAMIQUE.contact.titre")}</Typography>
                                <Stack gap={1.5} mt={1}>
                                    {[
                                        { icone: <Place />, label: t("FINANCE_ISLAMIQUE.contact.siege_label"), valeur: t("FINANCE_ISLAMIQUE.contact.siege") },
                                        { icone: <Phone />, label: t("FINANCE_ISLAMIQUE.contact.telephone_label"), valeur: t("FINANCE_ISLAMIQUE.contact.telephone") },
                                        { icone: <Email />, label: t("FINANCE_ISLAMIQUE.contact.email_label"), valeur: t("FINANCE_ISLAMIQUE.contact.email") },
                                    ].map((c, i) => (
                                        <Box key={i} sx={{ display: "flex", gap: 2, alignItems: "center", bgcolor: "rgba(255,255,255,.1)", borderRadius: 3, p: 2, textAlign: "left" }}>
                                            <Box sx={{ bgcolor: ORANGE, borderRadius: 2, p: 1, display: "flex" }}>{c.icone}</Box>
                                            <Box>
                                                <Typography variant="caption" sx={{ opacity: .8, textTransform: "uppercase" }}>{c.label}</Typography>
                                                <Typography fontWeight="bold" sx={{ wordBreak: "break-word" }}>{c.valeur}</Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                </Stack>
                            </Grid>
                        </Grid>
                    </Paper>
                </motion.div>
            </Container>

            <br /><br /><br /><br />

            <Footer />
        </div>
    )
}
//ok
export default FinanceIslamique
